import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import LockIcon from "@mui/icons-material/Lock";
import EditIcon from "@mui/icons-material/EditOutlined";
import { useFinance } from "../FinanceContext";
import { MONTHS } from "../data/seedData";

/** Row of 12 chips showing which fiscal months are frozen vs editable. */
export function FreezeStrip() {
  const { locks } = useFinance();
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mb: 1.5 }}>
      {MONTHS.map((m, i) => (
        <Chip
          key={m}
          size="small"
          variant={locks[i] ? "filled" : "outlined"}
          color={locks[i] ? "default" : "info"}
          icon={locks[i] ? <LockIcon fontSize="small" /> : <EditIcon fontSize="small" />}
          label={m.split(" ")[0]}
        />
      ))}
    </Box>
  );
}
